import { render, staticRenderFns } from "./Perks.vue?vue&type=template&id=5969226e&scoped=true&"
import script from "./Perks.vue?vue&type=script&lang=js&"
export * from "./Perks.vue?vue&type=script&lang=js&"
import style0 from "./Perks.vue?vue&type=style&index=0&id=5969226e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5969226e",
  null
  
)

export default component.exports